import React from "react";
import CheckboxTree from "react-checkbox-tree";
import {
  changeMapLayer,
  disableMapLayer,
} from "../../../redux/actions/map.action";
import { connect } from "react-redux";
import { showMapLayer } from "../../../redux/actions/menu.action";
import { message } from "antd";
import { withRouter } from "react-router";

class MapLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked_LopNen: ["RanhGioiDiaChinh", "BienSoNha"],
      expanded_LopNen: [],

      checked_LopDuLieu: [],
      expanded_LopDuLieu: [],

      isDisableLopNen: false,
    };

    this.LopDuLieu = [
      "QuyHoachChiTiet",
      // "QuyHoachPhankhu",
      // "QuyHoachChung",
      // "KienTruc",
    ];

    this.TreeLopDuLieu = [
      {
        label: "Vùng/Khu dự án",
        value: "500",
        children: [
          {
            label: 'Dự án',
            value: 'QHCT_Polygon',
          },

          // {
          //   label: 'Mặt bằng dạng Line',
          //   value: 'QHCT_Line',
          // },

          {
            label: 'Ranh giới Vùng/Khu dự án',
            value: 'QHCT_RanhGioi',
          },
        ],
      },

      // {
      //   label: "Quy hoạch phân khu 1/5000",
      //   value: "5000",
      //   children: [
      //     {
      //       label: "Mặt bằng dạng Polygon",
      //       value: "QHPK_Polygon",
      //     },

      //     {
      //       label: "Mặt bằng dạng Line",
      //       value: "QHPK_Line",
      //     },

      //     {
      //       label: "Ranh giới quy hoạch",
      //       value: "QHPK_RanhGioi",
      //     },
      //   ],
      // },

      // {
      //   label: "Quy hoạch chung 1/10000",
      //   value: "10000",
      //   children: [
      //     {
      //       label: "Mặt bằng dạng Polygon",
      //       value: "QHC_Polygon_All",
      //       children: [
      //         {
      //           label: "Quy Hoạch",
      //           value: "QHC_Polygon",
      //         },

      //         {
      //           label: "Hiện trạng",
      //           value: "QHC_HienTrang",
      //         },
      //       ],
      //     },

      //     {
      //       label: "Mặt bằng dạng Line",
      //       value: "QHC_Line",
      //     },

      //     {
      //       label: "Ranh giới quy hoạch",
      //       value: "QHC_RanhGioiQuyHoach",
      //     },

          
      //   ],
      // },

      // {
      //   label: "Kiến trúc",
      //   value: "KienTruc",
      // },
    ];

    this.TreeLopNen = [
      {
        label: "Bản đồ địa chính",
        value: "BanDoDiaChinh",
        children: [
          {
            label: "Ranh giới địa chính",
            value: "RanhGioiDiaChinh",
          },

          {
            label: "Thông tin địa chính",
            value: "ThongTinDiaChinh",
          },
          {
            label: "Ranh giới hành chính",
            value: "RanhGioiHanhChinh",
          },
        ],
      },

      {
        label: "Bản đồ 64",
        value: "BanDo64",
      },

      {
        label: "Biển số nhà",
        value: "BienSoNha",
      },
    ];
  }

  componentDidMount() {
    this.props.disableMapLayer(false);
    if (this.props.isEnableLayer) {
      let listLopNen = [
        "RanhGioiDiaChinh",
        "ThongTinDiaChinh",
        "RanhGioiHanhChinh",
        "BanDo64",
        "BienSoNha",
      ];
      let checked_LopNen = [];
      let checked_LopDuLieu = [];

      this.props.isEnableLayer.forEach((e) => {
        if (listLopNen.includes(e)) {
          checked_LopNen.push(e);
        } else {
          checked_LopDuLieu.push(e);
        }
      });
      this.setState({
        checked_LopNen,
        checked_LopDuLieu,
      });
    }
    this.unlisten = this.props.history.listen((location, action) => {
      message.destroy()
    });

  }
  componentWillUnmount() {
    message.destroy()
    this.unlisten();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log('this.state.checked_LopDuLieu',this.state.checked_LopDuLieu);
    console.log('this.props',this.props.isEnableLayer);
    if (prevProps.isEnableLayer !== this.props.isEnableLayer) {
      if (this.state.checked_LopDuLieu.length > 1) {
        message.open({
          content: (
            <div
              style={{
                width: "650px",
                display: "flex"
              }}
            >
              <i
                className="fas fa-info-circle"
                style={{
                  fontSize: "16px",
                  marginRight: "10px",
                  color: "#1F86EB",
                  marginTop: "5px"
                }}
              />

              <div style={{
                fontSize: "14px",
                fontFamily: "sans-serif",
                fontFamily: "Roboto",
                textAlign: "justify"
              }}>
                Khi mở nhiều hơn 1 lớp dữ liệu, hệ thống sẽ ưu tiên hiển thị thông tin lớp dữ liệu theo thứ tự: Quy hoạch chi tiết 1/500, Quy hoạch phân khu 1/5000, Quy hoạch chung 1/10000, Kiến trúc
              </div>
            </div>
          ),
        });
      }
    }    
    if (prevProps.isResetLayer !== this.props.isResetLayer) {
      this.onCheckLopDuLieu([])
      
    }
  }
  componentWillUnmount (){
    message.destroy()
  }

  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async onCheckLopNen(checked) {
    await this.SetStateAsync({ checked_LopNen: checked });
    this.getAllChecked();
  }

  onExpandLopNen(expanded) {
    this.setState({ expanded_LopNen: expanded });
  }

  async onCheckLopDuLieu(checked) {
    await this.SetStateAsync({ checked_LopDuLieu: checked });
    this.getAllChecked();
  }

  onExpandLopDuLieu(expanded) {
    this.setState({ expanded_LopDuLieu: expanded });
  }

  getAllChecked() {
    let list = ["LopDuLieu", "LopNen"];
    let checkList = [];
    list.forEach((e) => {
      this.state[`checked_${e}`].forEach((o) => {
        checkList.push(o);
      });
    });
    this.props.changeMapLayer(checkList);
    return checkList;
  }

  render() {
    console.log('this.props.isShowMenu', this.props.isShowMenu);
    return (
      <div className="map-layer">
        <div className="title-1">LỚP DỮ LIỆU</div>

        <CheckboxTree
          checked={this.state.checked_LopDuLieu}
          expanded={this.state.expanded_LopDuLieu}
          iconsClass="fa5"
          disabled={this.props.isDisableLayer}
          nodes={this.TreeLopDuLieu}
          onCheck={(e) => this.onCheckLopDuLieu(e)}
          onExpand={(e) => this.onExpandLopDuLieu(e)}
          showNodeIcon={false}
          icons={{
            check: (
              <i className="fas fa-check-square" style={{ color: "#1F86EB" }} />
            ),
            uncheck: <i className="far fa-square" />,
          }}
        />

        <div className="title-1" style={{ marginTop: "5px" }}>
          LỚP NỀN
        </div>

        <CheckboxTree
          checked={this.state.checked_LopNen}
          expanded={this.state.expanded_LopNen}
          iconsClass="fa5"
          disabled={this.props.isDisableLayer}
          nodes={this.TreeLopNen}
          onCheck={(e) => this.onCheckLopNen(e)}
          onExpand={(e) => this.onExpandLopNen(e)}
          showNodeIcon={false}
          icons={{
            check: (
              <i className="fas fa-check-square" style={{ color: "#1F86EB" }} />
            ),
            uncheck: <i className="far fa-square" />,
          }}
        />

        <div>
          <i
            className="fas fa-chevron-circle-left icon-resize"
            style={{ fontSize: "24px", left: `${this.props.isShowMenu ? "598px" : "370px"}` }}
            onClick={() => {
              this.props.showMapLayer(false);
            }}
          ></i>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
    isDisableLayer: state.map.isDisableLayer,
    isShowMenu: state.menu.isShowMenu,
    isResetLayer: state.menu.isResetLayer,
  };
};

const mapDispatchToProps = {
  changeMapLayer: changeMapLayer,
  disableMapLayer: disableMapLayer,
  showMapLayer: showMapLayer,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MapLayer));
